import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-900 via-teal-800 to-teal-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Логотип и описание */}
          <div>
            <div className="mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/7fffb91f-5f53-4051-921b-39ed0fb3fd56/e53a30a6-3038-4920-be13-e122df719f57_w1a424de2-804d-41f8-8e1b-2c3badd94023.png?v=2236fc9176eacedd36bde2691e97c3c8"
                alt="Zimbet32 Logo"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-teal-100 text-sm leading-relaxed mb-6">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-teal-700 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-teal-700 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-teal-700 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Быстрые ссылки */}
          <div>
            <h3 className="text-lg font-semibold mb-6">{t('footer.quickLinks')}</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  {t('nav.home')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  {t('nav.about')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  {t('nav.services')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('doctors')}
                  className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  {t('nav.doctors')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  {t('nav.contact')}
                </button>
              </li>
            </ul>
          </div>

          {/* Контактная информация */}
          <div>
            <h3 className="text-lg font-semibold mb-6">{t('footer.contactInfo')}</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-xl text-teal-300 mt-0.5"></i>
                <span className="text-teal-100 text-sm">{t('contact.info.addressValue')}</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-xl text-teal-300 mt-0.5"></i>
                <span className="text-teal-100 text-sm">{t('contact.info.phoneValue')}</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-xl text-teal-300 mt-0.5"></i>
                <span className="text-teal-100 text-sm">{t('contact.info.emailValue')}</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-time-line text-xl text-teal-300 mt-0.5"></i>
                <span className="text-teal-100 text-sm">{t('contact.info.hoursValue')}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Копирайт */}
      <div className="border-t border-teal-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <p className="text-center text-teal-200 text-sm">
            © {new Date().getFullYear()} {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}